<template>
  <div>
    <h1 id="jump-to-header">{{heading || "Update"}}</h1>
    <feature-update :id="id"/>
    <polymorphic-reference-index
      :filtering="filtering_reference"
      :ams_template="ams_template_reference"
     ></polymorphic-reference-index>
  </div>
</template>

<script>
import FeatureUpdate from './FeatureUpdate.vue'
import PolymorphicReferenceIndex from './PolymorphicReferenceIndex.vue'

export default {
  components: {
    FeatureUpdate,
    PolymorphicReferenceIndex
  },
  props: {
    id: String,
    heading: {
      Type: String
    }
  },
  data () {
    return {
      filtering_reference: {
        reference_to_type: 'Feature',
        reference_to_id: this.id
      },
      ams_template_reference: {
        type: 'polymorphic-references',
        description: undefined,
        attributes: {
          'reference-to-type': "Feature",
          'reference-to-id': this.id
        }
      },
      attrs: {}
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>
